import { FC, ReactElement, ReactNode } from 'react';
import usercentrics from '../../services/usercentrics';
import { useCookieConsentStore } from '../../stores/cookie-consent/use-cookie-consent-store';
import isUITest from '../../utils/is-ui-test';

type ConsentSensitiveProps = {
    children: ReactNode | ReactElement | string;
    type: string | string[];
};

const ConsentSensitive: FC<ConsentSensitiveProps> = ({ children, type }) => {
    const cookieConsentServices = useCookieConsentStore((state) => state.services);
    const isCookieAccepted = usercentrics.isServiceAccepted(cookieConsentServices, type);

    // Don't block content for UI tests
    if (isCookieAccepted || isUITest()) {
        return <>{children}</>;
    }

    return null;
};

export default ConsentSensitive;
